import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {toast} from "react-toastify";
import { erpApi } from "@/shared/axios";
import { handleAxiosError } from '@/shared/utils';
import { AprobadorArea,  AsignarAreaAprobadorPayload, GetAprobadorParams } from '@/erp/controlcambios/areascontrolcambios';
import {  useFetchUsuariosSistemaPorArreglo, GetUsuariosSistemaParams } from "@/shared/actions/erp/administration/usuarios";
import { urlBackend } from "@/shared/constants";
import { UsuariosSistemaGetExtras } from "@/shared/interfaces";
const {post, get, patch, remove} = erpApi();
const BASE_URL_CAMBIOS = `${urlBackend}api/v1/cambios/`;

export const postAsignarAreaAprobador = async (payload: AsignarAreaAprobadorPayload) => {
  return await post(`${BASE_URL_CAMBIOS}aprobadores-area`, payload, true)
}


export const useFetchPostAsignarAreaAprobador = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postAsignarAreaAprobador,
    onSuccess: () => {
      toast.success('Usuario unido al área correctamente');
      queryClient.invalidateQueries({ queryKey: ['aprobador'] });  
      queryClient.invalidateQueries({queryKey:['aprobacionareas']});
    },
    onError: (error) => {
      handleAxiosError(error);
    },
  })
}
///**GET */

// export const getVerAreaAprobador = async (params?: GetAprobadorParams) => {
export const getVerAreaAprobador = async (_params?: GetAprobadorParams): Promise<AprobadorArea[]> => {
  return (await get<AprobadorArea[]>(
      `${BASE_URL_CAMBIOS}aprobadores-area`,
       true
  )) as unknown as AprobadorArea[];
}


export const useFetchGetAprobadorArea = (
  params?: GetAprobadorParams,
  enabled = true
) => {
  
    return useQuery({
      queryKey: ['aprobador', ...Object.values(params ?? {})],
      queryFn: async () => {  return getVerAreaAprobador(params)},
      enabled,
    });
};

//todo junto

export const useAprobadoresArea = (params?:GetUsuariosSistemaParams ) => {
  const aprobadoresQuery = useFetchGetAprobadorArea();

  const ids =aprobadoresQuery.data?.map((item) => item.usuarioId) ?? [];

  const usuariosQuery =
    useFetchUsuariosSistemaPorArreglo({
      enabled:
        aprobadoresQuery.isSuccess &&
        ids.length > 0,
      params: {
        usuarios: ids,
        page: params?.page,
        page_size: params?.page_size,
      },
    });

    const aprobadorPorId = new Map((aprobadoresQuery.data ?? []).map((a)=>[a.usuarioId, a]));
    const usuarios = (
    usuariosQuery.data?.data.data?.map((usuario: any) => {
      const aprobador = aprobadorPorId.get(usuario.id);
      return {
        ...usuario,
        activo: aprobador?.activo ?? null,
        puedeAprobar: aprobador?.puedeAprobar ?? null,
        area: aprobador?.area ?? null,
        aprobadorAreaId: aprobador?.aprobadorAreaId ?? null,
      };
    }) ?? []) as unknown as UsuariosSistemaGetExtras[];

    console.log("Usuarios",usuarios);
    return {
        ids,
        usuarios,
        total: usuariosQuery.data?.data.count ?? 0,

        isLoading: aprobadoresQuery.isLoading || usuariosQuery.isLoading,
        isRefetching:
          aprobadoresQuery.isRefetching || usuariosQuery.isRefetching,
        error: aprobadoresQuery.error || usuariosQuery.error,
      };

  // return {
  //   ids,
  //   usuarios:
  //     usuariosQuery.data?.data.data ?? [],
  //   total:
  //     usuariosQuery.data?.data.count ?? 0,

  //   isLoading:
  //     aprobadoresQuery.isLoading ||
  //     usuariosQuery.isLoading,

  //   isRefetching:
  //     aprobadoresQuery.isRefetching ||
  //     usuariosQuery.isRefetching,

  //   error:
  //     aprobadoresQuery.error ||
  //     usuariosQuery.error,
  // };
};

export const useAprobadoresConNombre = () => {
  // 1. Trae todos los aprobadores (con su área)
  const aprobadoresQuery = useFetchGetAprobadorArea();

  const aprobadores = aprobadoresQuery.data ?? [];
  
  const ids = aprobadores.map(a => a.usuarioId);
  console.log("usuario ids", ids);
  const usuariosQuery = useFetchUsuariosSistemaPorArreglo({
    enabled: aprobadoresQuery.isSuccess && ids.length > 0,
    params: { usuarios: ids, page: 0, page_size: 1000 },
  });
  console.log("usuario query", usuariosQuery);
  const usuarios = usuariosQuery.data?.data.data ?? [];
  // 3. Combinar: cada aprobador con su nombre, manteniendo el área
  const aprobadoresConNombre = aprobadores.map(ap => {
    const usuario = usuarios.find((u: any) => u.id === ap.usuarioId);
    return {
      usuarioId: ap.usuarioId,
      nombre:
        usuario?.profile?.razon_social ||
        usuario?.empleado?.razon_social ||
        usuario?.username ||
        usuario?.email ||
        `Usuario ${ap.usuarioId}`,
      areaId: ap.area?.areaId,         // ⬅️ mantiene la relación con el área
      areaNombre: ap.area?.nombre,
    };
  });
  return {
    aprobadores: aprobadoresConNombre,
    isLoading: aprobadoresQuery.isLoading || usuariosQuery.isLoading,
  };
}


export const useAprobadoresPorAreas = (areasIds: string[]) => {
  const query = useFetchGetAprobadorArea();

  const aprobadores = query.data ?? [];

  const filtrados = areasIds.length
    ? aprobadores.filter(a => areasIds.includes(a.area?.areaId ?? '') && a.puedeAprobar === true)
    : [];

  const ids = filtrados.map(a => a.usuarioId);

  const usuariosQuery = useFetchUsuariosSistemaPorArreglo({
    enabled: query.isSuccess && ids.length > 0,
    params: { usuarios: ids, paginate: false },
  });

  const usuarios = usuariosQuery.data?.data.data ?? [];


  const result = filtrados.map(ap => {

    const usuario = usuarios.find((u: any) => u.id === ap.usuarioId);

    return {
      usuarioId: ap.usuarioId,
      nombre:
        usuario?.profile?.razon_social ??
        usuario?.empleado?.razon_social ??
        usuario?.username ??
        `Usuario ${ap.usuarioId}`,
      areaId: ap.area?.areaId,
      areaNombre: ap.area?.nombre,
    };
  });

  return {
    aprobadores: result,
    isLoading: query.isLoading || usuariosQuery.isLoading,
  };
};


export const patchActualizarPuedeAprobar = async ({
  id,
  puedeAprobar,
}: {
  id: string;
  puedeAprobar: boolean;
}) => {
  return await patch(
    `${BASE_URL_CAMBIOS}aprobadores-area/${id}/puede-aprobar?puedeAprobar=${puedeAprobar}`,
    undefined,
    true
  );
};

export const useFetchPatchPuedeAprobar = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchActualizarPuedeAprobar,
    onSuccess: () => {
      toast.success('Permiso de aprobación actualizado correctamente');
      queryClient.invalidateQueries({ queryKey: ['aprobador'] });
      queryClient.invalidateQueries({ queryKey: ['aprobacionareas'] });
    },
    onError: (error) => {
      handleAxiosError(error);
    },
  });
};


export const patchActualizarActivo = async ({
  id,
  activo,
}: {
  id: string;
  activo: boolean;
}) => {
  return await patch(
    `${BASE_URL_CAMBIOS}aprobadores-area/${id}/activo?activo=${activo}`,
    undefined,
    true
  );
};

export const useFetchPatchActivo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchActualizarActivo,
    onSuccess: () => {
      toast.success('Estado del aprobador actualizado correctamente');
      queryClient.invalidateQueries({ queryKey: ['aprobador'] });
      queryClient.invalidateQueries({ queryKey: ['aprobacionareas'] });
    },
    onError: (error) => {
      handleAxiosError(error);
    },
  });
};


/////
// eliminar
export const deleteAprobador = async (id: string) =>
  await remove(`${BASE_URL_CAMBIOS}aprobadores-area/${id}`, true);

export const useFetchDeleteAprobador = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteAprobador,
    onSuccess: () => {
      toast.success('Aprobador eliminado correctamente');
      queryClient.invalidateQueries({ queryKey: ['aprobador'] });
    },
    onError: (error) => handleAxiosError(error),
  });
};

// cambiar área
export const patchCambiarAreaAprobador = async ({ id, areaId }: { id: string; areaId: string }) =>
  await patch(`${BASE_URL_CAMBIOS}aprobadores-area/${id}/area?areaId=${areaId}`, undefined, true);

export const useFetchPatchCambiarArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchCambiarAreaAprobador,
    onSuccess: () => {
      toast.success('Área del aprobador actualizada');
      queryClient.invalidateQueries({ queryKey: ['aprobador'] });
    },
    onError: (error) => handleAxiosError(error),
  });
};
